import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import ChartComponent from './ChartComponent';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const ChartTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const HighchartModal = (props) => {
  const { handleClose, highchartData, msg, open, type } = props
   
  return (
    <Dialog
      fullWidth
      id={msg?.questionId+ '_modal'}
      aria-labelledby="customized-dialog-title"
      maxWidth='lg'
      onClose={handleClose}
      open={open}
    >
      <ChartTitle id="customized-dialog-title" onClose={handleClose}>
        {msg?.queryText}
      </ChartTitle>
      <DialogContent dividers>
        <ChartComponent
          chartType={type}
          addCustomStyles={false}
          responseData={highchartData}
          chartData={highchartData?.chartData || {}}
          id={1}
          title={msg?.queryText}
          chartUniqueId={msg?.questionId+ '_modal'}
        />
      </DialogContent>
    </Dialog>
  );
}

export default HighchartModal